import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { EndPoint } from "@endpoint";
import { LoginServices } from "@login";
import { Store as AppStore } from "@ngrx/store";
import { AppState } from "@store/state";
import { BaseGetProvider } from "@tendercuts/http";
import { GramInventory } from "@tendercuts/models";

@Injectable({
  providedIn: "root",
})
export class FetchInventoryDebugEntryService extends BaseGetProvider<GramInventory> {
  constructor(
    public http: HttpClient,
    public endpointService: EndPoint,
    public store: AppStore<AppState>,
    public loginService: LoginServices,
  ) {
    super(http);
    this.delegate = this;
  }

  get isAuthenticatedEndpoint(): boolean {
    return true;
  }

  get authProtocol(): LoginServices {
    return this.loginService;
  }

  preProcessResponse(response: any): Array<any> {
    return response.results;
  }

  get model(): typeof GramInventory {
    return GramInventory;
  }

  get isCachable(): boolean {
    return false;
  }

  get endpoint(): string {
    return this.endpointService.inventoryEntry();
  }

  getParams(
    storeId: number,
    productId: number,
    date: Date,
  ): {
    store_id: number;
    product_id: number;
    date: string;
  } {
    date.setTime(date.getTime() + 5.5 * 60 * 60 * 1000);

    const params: {
      store_id: number;
      product_id: number;
      date: string;
    } = {
      store_id: storeId,
      product_id: productId,
      date: date.toISOString().split("T")[0],
    };

    return params;
  }
}
